import { Chart, Plugin } from 'chart.js';

export const CHART_ANIMATIONS_OFF_SELECTOR = '[data-chart-animations="off"]';

const firstRenderDone = new WeakSet<Chart>();

export const animateFirstDataRenderOnlyPlugin: Plugin = {
  id: 'animateFirstDataRenderOnly',
  beforeUpdate(chart: Chart) {
    if (firstRenderDone.has(chart) || chart.canvas?.closest(CHART_ANIMATIONS_OFF_SELECTOR)) {
      chart.options.animation = { duration: 0, delay: 0 };
    } else if (chart.data.datasets.some((dataset) => (dataset.data?.length ?? 0) > 0)) {
      firstRenderDone.add(chart);
    }
  },
};
